export const publicRoutes = [
  '/login',
  '/auth',
  '/callback',
  '/login/confirm',
  '/login/recover',
  '/login/accept-invitation',
  '/login/magic-link',
  '/error',
];

export const freeAccessRoutes = [...publicRoutes, '/account', '/api-keys', '/payment-required'];

export interface RestrictedRoute {
  route: string;
  permission: string | null;
}

// List of restricted routes and their required permissions
export const restrictedRoutes: RestrictedRoute[] = [
  {
    route: '/live-benchmarking',
    permission: 'read:live_benchmarking',
  },
  {
    route: '/browse',
    permission: 'read:files',
  },
  {
    route: '/power',
    permission: 'read:power_forecast_v0',
  },
  {
    route: '/market-aggregates',
    permission: 'read:market_aggregates',
  },
  {
    route: '/map',
    permission: null,
  },
  {
    route: '/oracle',
    permission: 'read:oracle',
  },
];
